import { makeVar } from "@apollo/client";

export const isTicketSoldOutForUpcomingRecurringEvents = makeVar(false);
